module.exports = __webpack_public_path__ + "static/media/agilite.fe92d251.png";